// extracted by mini-css-extract-plugin
export default {"slot":"slot__2IHoX","selected":"selected__3odNW","inProgress":"inProgress__3UI1R"};
    if(module.hot) {
      // 1764953375345
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  